import React, { useState } from "react";
import { Accordion, Button } from "react-bootstrap";
import "./style.css";
import ContactUsOne from "../ContactUS/contactUsOne";
import ContactUsTwo from "../ContactUS/contackUsTwo";
import PurchaseForm from "./Purchase/purchaseForm";


const Features = () => {
  const [activeModal, setActiveModal] = useState(null);
  const [featureName, setFeatureName] = useState(null);

  const plans = [
    {
      title: "Regular Business",
      price: "$10/month",
      description:
        "Includes all essential features for medium-sized businesses.",
      features: [
        "Social media integration",
        "Emails to customers",
        "Upload multiple recorded classes",
        "Create quizzes, assignments, housework, etc",
        "Create & edit videos",
        "Add captions in multiple languages",
        "Create schedule live video classes",
        "Students reports",
        "Schedule in-person appointernents",
        "Offer & promotions",
        "Setup booking & cancellation deadlines",
        "Business reports",
      ],
    },
    {
      title: "Single Person Owned/ Managed Business",
      price: "$20/month",
      description:
        "This model suits the business where a single person owns and manages the entire business. You cannot add additional resources in this model.",
      features: [
        "Social media integration",
        "Emails to customers",
        "Upload multiple recorded classes",
        "Create quizzes, assignments, housework, etc",
        "Create & edit videos",
        "Add captions in multiple languages",
        "Create schedule live video classes",
        "Students reports",
        "Schedule in-person appointernents",
        "Offer & promotions",
        "Setup booking & cancellation deadlines",
        "Business reports",
      ],
    },
    {
      title: "Social Media Managed Business",
      price: "$10/month",
      description:
        "This model suits the business where a single person owns and manages the entire business. You cannot add additional resources in this model.",
      features: [
        "Social media integration",
        "Emails to customers",
        "Upload multiple recorded classes",
        "Create quizzes, assignments, housework, etc",
        "Create & edit videos",
        "Add captions in multiple languages",
        "Create schedule live video classes",
        "Students reports",
        "Schedule in-person appointernents",
        "Offer & promotions",
        "Setup booking & cancellation deadlines",
        "Business reports",
      ],
    },
    {
      title: "Universities/Colleges/Schools",
      price: "Contact Us",
      description: "Customized solutions for educational institutions.",
    },
    {
      title: "Mobile App",
      price: "Contact Us",
      description: "Tailored mobile application for your business needs.",
    },
  ];

  return (
    <div id="features">
      <div className="featuresWrapper mb-5">
        <h2 className="text-center mb-3">Features</h2>
        <p className="text-center text-muted">
          Choose a plan according to your <a href="#">business model</a>
        </p>
      </div>

      <div className="Accordion container">
        <Accordion>
          {plans.map((plan, index) => (
            <Accordion.Item eventKey={index.toString()} key={index}>
              <Accordion.Header>
                <div className="custom-header d-flex align-items-center">
                  <div className="accordion-arrow me-2"></div>
                  <div className="d-flex justify-content-between w-100">
                    <span>{plan?.title}</span>
                    <span>{plan?.price}</span>
                  </div>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <p>{plan.description}</p>
                {plan?.features && (
                  <ul className="features-list">
                    {plan.features.map((feature, idx) => (
                      <li key={idx}>
                        <span className="checkmark">&#10003;</span> {feature}
                      </li>
                    ))}
                  </ul>
                )}

                {plan.title === "Universities/Colleges/Schools" ||
                  plan.title === "Mobile App" ? (
                  <Button
                    variant="btn primary"
                    onClick={() => {
                      if (plan.title === "Universities/Colleges/Schools") {
                        setActiveModal("contactUsOne");
                      } else if (plan.title === "Mobile App") {
                        setActiveModal("contactUsTwo");
                      }
                    }}
                  >
                    Contact us
                  </Button>
                ) : (
                  <Button 
                  variant="btn primary" 
                  onClick={() => { 
                    setActiveModal("purchaseForm"); 
                    setFeatureName(plan?.title); 
                  }}
                >
                  Purchase
                </Button>
                
                )}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>

      {/* Modals */}
      <ContactUsOne
        show={activeModal === "contactUsOne"}
        handleClose={() => setActiveModal(null)}
      />
      <ContactUsTwo
        isOpen={activeModal === "contactUsTwo"}
        onClose={() => setActiveModal(null)}
      />
      <PurchaseForm
        show={activeModal === "purchaseForm"}
        handleClose={() => setActiveModal(null)}
        featureName={featureName}
      />


    </div>
  );
};

export default Features;
